import React from 'react';
import MarkdownRenderer from './MarkdownRenderer';
import attachmentService from '../../services/attachmentService';

// Helper component to fetch and render markdown content
const MarkdownFetcher = ({ url, file }) => {
  const [content, setContent] = React.useState('加载中...');
  const [loading, setLoading] = React.useState(true);

  // 处理URL，只在开发环境使用代理（与PDFViewer相同的逻辑）
  const getProxyUrl = (originalUrl) => {
    if (!originalUrl) return originalUrl;

    // 只在开发环境且URL包含后端域名时，转换为通过代理访问
    if (
      import.meta.env.MODE === 'dev' &&
      originalUrl.includes('dev.service.syntrust.inside.h2os.cloud:7000')
    ) {
      // 提取路径部分：/v1/syntrust/attachments/...
      const urlObj = new URL(originalUrl);
      return urlObj.pathname + urlObj.search;
    }

    return originalUrl;
  };

  React.useEffect(() => {
    const fetchMarkdown = async () => {
      try {
        let markdownContent = '';
        
        // 优先使用file.content字段（最新的内容）
        if (file?.content) {
          markdownContent = file.content;
        } else if (file?.fields?.content) {
          markdownContent = file.fields.content;
        } else if (url) {
          // 如果本地没有content，通过URL获取
          try {
            const proxyUrl = getProxyUrl(url);
            const response = await fetch(proxyUrl);
            if (response.ok) {
              markdownContent = await response.text();
            } else {
              throw new Error('Failed to fetch markdown');
            }
          } catch (fetchError) {
            setContent('无法加载Markdown文件（CORS错误）');
            setLoading(false);
            return;
          }
        }

        setContent(markdownContent);
      } catch (error) {
        console.error('Error fetching markdown:', error);
        setContent('加载失败');
      } finally {
        setLoading(false);
      }
    };

    if (url || file) {
      fetchMarkdown();
    }
  }, [url, file?.content, file?.fields?.content]);

  if (loading) {
    return <div className="text-center p-5">加载中...</div>;
  }

  return <MarkdownRenderer content={content} />;
};

export default MarkdownFetcher;
